/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';

/**
 * 
 * @export
 * @interface FindAllPalReauthCaseManagersResponse
 */
export interface FindAllPalReauthCaseManagersResponse {
    /**
     * 
     */
    data: Array<PalReauthCaseManager>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllPalReauthCaseManagersResponse interface.
 */
export function instanceOfFindAllPalReauthCaseManagersResponse(value: object): value is FindAllPalReauthCaseManagersResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllPalReauthCaseManagersResponseFromJSON(json: any): FindAllPalReauthCaseManagersResponse {
    return FindAllPalReauthCaseManagersResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthCaseManagersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalReauthCaseManagerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllPalReauthCaseManagersResponseToJSON(json: any): FindAllPalReauthCaseManagersResponse {
    return FindAllPalReauthCaseManagersResponseToJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagersResponseToJSONTyped(value?: FindAllPalReauthCaseManagersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PalReauthCaseManagerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

